import { Component, Inject, OnInit, OnDestroy  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { parseFinanceNumber } from '../../finance.helpers';
import { Finance } from '../../finance.types';
import { HotkeyService } from 'src/app/core/services/hotkey.service';

export interface DialogData {
    finance: Finance;
}

@Component({
    selector: 'finance-delete-dialog',
    templateUrl: 'finance-delete-dialog.component.html',
    styleUrls: ['finance-delete-dialog.component.scss'],
})
export class FinanceDeleteDialog implements OnInit, OnDestroy {
    constructor(
        public dialogRef: MatDialogRef<FinanceDeleteDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private hotkeyService: HotkeyService
    ) {}

    ngOnInit(): void {
        // Register hotkey for "Cancel" action (Ctrl + Q)
        this.hotkeyService.registerHotkey('ctrl+q', 'Cancel action', () => this.onCancel());
    }

    getFinanceNumber(financeId, financeType, versionNumber) {
        return parseFinanceNumber(financeId, financeType, versionNumber);
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        // Unregister the hotkey when the dialog is destroyed
        this.hotkeyService.unregisterHotkey('ctrl+q');
    }
}
